import { render, staticRenderFns } from "./ProductApprovalResultField.vue?vue&type=template&id=1dfd72a6&scoped=true&"
import script from "./ProductApprovalResultField.vue?vue&type=script&lang=js&"
export * from "./ProductApprovalResultField.vue?vue&type=script&lang=js&"
import style0 from "./ProductApprovalResultField.vue?vue&type=style&index=0&id=1dfd72a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd72a6",
  null
  
)

export default component.exports